module.exports = __webpack_public_path__ + "static/media/czytane_naglos_polecenia.fd327961.svg";